/**
 * Labstep
 *
 * @module components/Metadata/Value/Options
 * @desc Metadata Value
 */

import { Flex } from 'labstep-web/core/Flex';
import type React from 'react';
import { Label } from 'semantic-ui-react';
import type { MetadataValueOptionsProps } from './types';

export const MetadataValueOptions: React.FC<
  MetadataValueOptionsProps
> = ({ metadata }) => (
  <Flex wrap>
    {metadata.optionsSelectedValues.map((option) => (
      <Label key={option} circular>
        {option}
      </Label>
    ))}
  </Flex>
);
